import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ab8505f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "black-darken-500" }

import { computed } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppSnackbar',
  setup(__props) {

const store = useStore();
const snackbar = computed(
  () => store.getters["snackbarService/selectSnackbar"]
);
const message = computed(() => store.getters["snackbarService/selectMessage"]);
const color = computed(() => store.getters["snackbarService/selectColor"]);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    location: "top",
    modelValue: snackbar.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((snackbar).value = $event)),
    color: color.value,
    id: "snackbar"
  }, {
    action: _withCtx(({ attrs }) => [
      _createVNode(_component_v_btn, _mergeProps({ text: "" }, attrs, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (snackbar.value = false))
      }), {
        default: _withCtx(() => [
          _createTextVNode(" Закрыть ")
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(message.value), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "color"]))
}
}

})